import { KYBStatusEnum, KYBStepsEnum } from "@finway-group/shared/lib/models"
import { type Dispatch } from "redux"
import { CorporateService } from "~Shared/services"
import { WalletService } from "~Shared/services/wallet.service"
import {
    CorporateActionTypes,
    type FetchKYBProgressAction,
    type ResetWalletAction,
    type SetCurrentKYBStepAction,
    type SetKYBDataAction,
    type SetWalletAction,
} from "~Shared/store/actions/corporate/corporateTypes"
import { type KYBData, type Wallet } from "~Shared/store/reducers/corporateReducer"

const getCurrentStep = ({ corporateId, isEmailVerified, isPasswordCreated, isMobileVerified, kybStatus }: KYBData): KYBStepsEnum => {
    if (kybStatus === KYBStatusEnum.APPROVED) {
        return KYBStepsEnum.CREATE_ACCOUNT
    }
    if (isMobileVerified) {
        return KYBStepsEnum.KYB_FORM
    }
    if (isEmailVerified) {
        return KYBStepsEnum.VERIFY_MOBILE
    }
    if (isPasswordCreated) {
        return KYBStepsEnum.VERIFY_EMAIL
    }
    if (corporateId) {
        return KYBStepsEnum.CREATE_PASSWORD
    }
    return KYBStepsEnum.COMPANY_DETAILS
}

export const fetchKYBProgress = () => async (dispatch: Dispatch) => {
    try {
        const kybProgress = await CorporateService.getKYBProgress()
        const currentKYBStep = getCurrentStep(kybProgress)

        const action: FetchKYBProgressAction = {
            type: CorporateActionTypes.FETCH_KYB_PROGRESS,
            kybData: kybProgress,
            currentKYBStep,
        }
        dispatch(action)
    } catch (err) {
        setCurrentKYBStep(KYBStepsEnum.COMPANY_DETAILS)
    }
}

export const setKYBData = (kybData: KYBData) => (dispatch: Dispatch) => {
    const action: SetKYBDataAction = {
        type: CorporateActionTypes.SET_KYB_DATA,
        kybData,
    }

    dispatch(action)
}

export const setCurrentKYBStep = (currentKYBStep: KYBStepsEnum) => (dispatch: Dispatch) => {
    const action: SetCurrentKYBStepAction = {
        type: CorporateActionTypes.SET_CURRENT_KYB_STEP,
        currentKYBStep,
    }

    dispatch(action)
}

export const setWallet = (wallet: Wallet) => (dispatch: Dispatch) => {
    const action: SetWalletAction = {
        type: CorporateActionTypes.SET_WALLET,
        wallet,
    }

    dispatch(action)
}

export const fetchWallet = () => async (dispatch: Dispatch) => {
    const wallet = await WalletService.fetchWalletDetails()

    const action: SetWalletAction = {
        type: CorporateActionTypes.SET_WALLET,
        wallet,
    }

    dispatch(action)

    return wallet
}

export const resetWallet = () => (dispatch: Dispatch) => {
    const action: ResetWalletAction = {
        type: CorporateActionTypes.RESET_WALLET,
    }

    dispatch(action)
}
